import styled from 'styled-components';

const CommentCountContainer = styled.div<{ $isCompactStyle?: boolean }>`
    position: absolute;
    top: ${(p) => (p.$isCompactStyle ? '2px' : '4px')};
    right: 4px;
    width: 30px;
    height: 25px;
`;

const CommentCountLabel = styled.div<{ $isRead?: boolean }>`
    position: absolute;
    left: 0;
    top: 2px;
    width: 100%;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    color: ${(p) => (p.$isRead ? '#000000' : '#ffffff')};
`;

const SpeechBubbleIconSvg = styled.svg`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
`;

interface SpeechBubbleIconProps {
    fillColor: string;
    strokeColor: string;
    opacity: number;
}

const SPEECH_BUBBLE_PATH = [
    'M 15 1',
    'h 10',
    'a 4 4 0 0 1 4 4',
    'v 10',
    'a 4 4 0 0 1 -4 4',
    'l -4 4',
    'l -4 -4',
    'h -12',
    'a 4 4 0 0 1 -4 -4',
    'v -10',
    'a 4 4 0 0 1 4 -4',
    'z',
].join(' ');

function SpeechBubbleIcon({
    fillColor,
    strokeColor,
    opacity,
}: SpeechBubbleIconProps) {
    return (
        <SpeechBubbleIconSvg width="30" height="25" viewBox="0 0 30 25">
            <path
                d={SPEECH_BUBBLE_PATH}
                fill={fillColor}
                stroke={strokeColor}
                opacity={opacity}
                stroke-width="2"
            />
        </SpeechBubbleIconSvg>
    );
}

export interface CommentCountProps {
    isRead: boolean;
    commentCount: number;
    isCompactStyle?: boolean;
}

const READ_PROPS = {
    fillColor: '#ffffff',
    strokeColor: '#000000',
    opacity: 0.2,
} as const;

const UNREAD_PROPS = {
    fillColor: '#40A9FF',
    strokeColor: '#40A9FF',
    opacity: 1,
} as const;

export function CommentCount({
    isRead,
    commentCount,
    isCompactStyle,
}: CommentCountProps) {
    return (
        <CommentCountContainer $isCompactStyle={isCompactStyle}>
            <SpeechBubbleIcon {...(isRead ? READ_PROPS : UNREAD_PROPS)} />
            <CommentCountLabel $isRead={isRead}>
                {commentCount}
            </CommentCountLabel>
        </CommentCountContainer>
    );
}
